import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'


//for theme
import './plugins/element.js'
import './plugins/theme.js'
// import './plugins/font-awesome.js'
import './plugins/http.js'
import './plugins/mixins.js'

//for plugin
import './plugins/plugin.js'


// import wrap from '@vue/web-component-wrapper'

// import Word from './components/dictionary/oxford/Word'
// import WordUI from './components/dictionary/oxford/WordUI'


// window.customElements.define('word', wrap(Vue, Word))
// window.customElements.define('WordUI', wrap(Vue, WordUI))

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
